const scoreGrades = {
  easy: "EASY",
  medium: "MEDIUM",
  hard: "HARD",
  suspended: "SUSPENDED",
};

export default scoreGrades;
